import { capitalizeFirstLetter } from './string';
import { CUSTOMER_TYPES } from '../apps/deliveries/constants/globals';

export const PAYMENT_METHODS = {
  STRIPE_BANK_ACCOUNT: 'stripe_ach',
  STRIPE_CREDIT_CARD: 'stripe_card',
  cod: 'cod',
  cash: 'cash',
  check: 'check',
};

/**
 * Checks whether customer has subscription with email
 * @param {object} customer - customer object
 * @param {string} email - email
 * @returns {boolean}
 */
export const customerHasSubscriptionForEmail = (customer, email) => {
  for (let i = 0; i < customer.emailSubscriptions.length; i++) {
    if (customer.emailSubscriptions[i].email === email) {
      return true;
    }
  }
  return false;
};

/**
 * Extracts subscriptions by email
 * @param {object} customer - customer object
 * @param {string} email - email
 * @returns {Array} - array of subscriptions which has specific email
 */
export const customerGetSubscriptionsByEmail = (customer, email) => {
  let subscriptions = [];
  for (let i = 0; i < customer.emailSubscriptions.length; i++) {
    if (customer.emailSubscriptions[i].email === email) {
      subscriptions.push(customer.emailSubscriptions[i]);
    }
  }
  return subscriptions;
};

/**
 * Extracts customer payment cards
 * @param {object} customer - customer object
 * @param {string} id - payment method id
 * @returns {object|boolean} - payment method|false
 */
export const customerGetPaymentMethodById = (customer, id) => {
  for (let i = 0; i < customer.paymentMethods.length; i++) {
    if (customer.paymentMethods[i].id === id) {
      return customer.paymentMethods[i];
    }
  }
  return false;
};

/**
 * Extracts customer payment cards
 * @param {object} customer - customer object
 * @returns {Array} - array of payment cards
 */
export const customerGetCreditCards = (customer) => {
  let cards = [];
  for (let i = 0; i < customer.paymentMethods.length; i++) {
    if (customer.paymentMethods[i].method === 'stripe_card') {
      cards.push(customer.paymentMethods[i]);
    }
  }
  return cards;
};

/**
 * Searches for default payment method
 * @param {object} customer - customer object
 * @returns {object|boolean}
 */
export const customerGetDefaultPaymentMethod = (customer) => {
  for (let i = 0; i < customer.paymentMethods.length; i++) {
    if (customer.paymentMethods[i].default) {
      return customer.paymentMethods[i];
    }
  }
  return false;
};

/**
 * Extracts customer payment cards
 * @param {object} customer - customer object
 * @returns {Array} - array of payment cards
 */
export const customerGetBankAccounts = (customer) => {
  let cards = [];
  for (let i = 0; i < customer.paymentMethods.length; i++) {
    if (customer.paymentMethods[i].method === 'stripe_ach') {
      cards.push(customer.paymentMethods[i]);
    }
  }
  return cards;
};

/**
 * Checks whether customer has payment methods
 * @param {object} customer - customer object
 * @param {string} type - payment method type
 * @returns {boolean} - whether bank accounts is available
 */
export const customerHasPaymentMethod = (customer, type) => {
  for (let i = 0; i < customer.paymentMethods.length; i++) {
    if (customer.paymentMethods[i].method === type) {
      return true;
    }
  }
  return false;
};

export const getDefaultAddressByCustomer = (customer, type) => {
  let address = '';
  type = capitalizeFirstLetter(type);

  if (typeof customer !== 'undefined' && customer[`default${type}Address`]) {
    address = customer[`default${type}Address`];
  }
  return address;
};

export function getCustomerName(customer) {
  if (customer?.type === CUSTOMER_TYPES.WHOLESALE) {
    return customer?.companyName || '';
  }

  if (customer?.type === CUSTOMER_TYPES.RETAIL && (customer?.firstName || customer?.lastName)) {
    return `${customer.firstName ? customer.firstName + ' ' : ''}${customer.lastName}`;
  }

  return '-';
}
